import { FormFields } from "../components/CompleteAccount/Stepper";

import * as Yup from "yup";

export const createValidationSchema = (fields: FormFields[]) => {
  const schemaFields: Record<string, Yup.AnySchema> = {};

  fields.forEach((field) => {
    const { name, notRequired, disabled, inputType } = field;

    if (notRequired || disabled) {
      schemaFields[name] = Yup.mixed().nullable();
    } else {
      if (inputType === "number") {
        schemaFields[name] = Yup.number()
          .typeError(`${field.label} Must Be A Number`)
          .required(`${field.label} Is Required`);
      } else {
        schemaFields[name] = Yup.string()
          .trim()
          .required(`${field.label} Is Required`);
      }
    }
  });

  return Yup.object().shape(schemaFields);
};

export const returnFormInitialValues = (fields: FormFields[]) => {
  const initialValues: Record<string, any> = {};
  for (let index = 0; index < fields.length; index++) {
    const element = fields[index];
    initialValues[element.name] = element.value || "";
  }
  return initialValues;
};
